<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading" >
    <mapfre-card [singleCard]="false" [additionalClasses]="'billing-request fs-18 lh-24  policy-acct-txt-color'">
        <div class="border-bottom-1-9CB0BC fs-16 pb-3 mb-4">
            <h1 class="title-cta mb-2 dm-sans">{{ "Refunds" | translate }}</h1>
            <ng-container *ngIf="policy.policyType.includes('AUTO')" >
                <p class="mb-0 lh-20-83">{{ "Refund amounts are the difference calculated between what is owed on the policy less any overpayments or credits." | translate }}</p>
            </ng-container>
        </div>
        
        <app-billing-header 
            [policyTypeImg]="policyTypeImg" [policyType]="policyType" 
            [policyNumber]="policy?.policynumber.policyNumber" [policy]="policy"
        >
        </app-billing-header>

        <ng-container>
            <form name="refundFormGroup" class="submit-question-form"
                    [formGroup]="refundFormGroup" (ngSubmit)="sendRequest()"
                    [ngClass]="'text-left ma-submit-question-form mt-4'">
 
                <div *ngFor="let input of inputs; index as index; " class="input" [ngClass]="{ 'mb-34': input.inputType === 'select' }">
                    <ng-container *ngIf="input.inputType === 'select'">
                        <label for="select-topic" class="select-label mb-0">{{ input.label | translate }}</label>     
                        <select required class="fs-16 mb8" [ngClass]="'custom-select'" name="select-topic" id="select-topic"
                            [formControlName]="input.key">  
                            <ng-container *ngIf="input.value === ''">
                                <option class="custom-select-font" value="" disabled selected>Select one</option>  
                            </ng-container>
                            <option *ngFor="let opt of input.options; index as index;" [value]="opt">
                                {{ opt }}
                            </option>
                        </select>
                    </ng-container>
                    
                    <ng-container *ngIf="input.inputType !== 'select' && refundFormGroup.controls.initiate_refund_topic.valid">                               
                        <div class="mb-4 mt-2">
                            <label for="select-topic" class="select-label mb-0">{{ input.label | translate }}</label> 
                            <textarea [formControlName]="input.key" [id]="'request-text'" [name]="'request-text'"
                                class="request-text" mdbInput>
                            </textarea>
                        </div>
                    </ng-container>   
                </div>

                <div class="row text-center">
                    <div class="col">
                        <mapfre-button
                            [additionalClasses]="'basic primary large-btn  mx-auto'"
                            [disabledValue]="refundFormGroup.controls.initiate_refund_topic.valid" 
                            [inputType]="'submit'"
                            [translateValue]="'SUBMIT' | translate"
                        ></mapfre-button>
                    </div>
                </div>

                <div class="row text-center mt-3">
                    <div class="col">
                        <mapfre-button 
                        [additionalClasses]="'ghost secondary large-btn mx-auto height-56'"
                        [iconClasses]="'align-middle'" 
                        (click)="onClickBack()">
                        {{ 'BACK' | translate }}
                        </mapfre-button>
                    </div>
                </div>
            </form>
        </ng-container>

    </mapfre-card>
</ng-container>
